// src/pages/products/SteeringClocksPage.tsx
import React from 'react';
import { Button, Modal, Input, Tag } from 'antd';
import { SteeringClockItem } from '../../types/ProductItems';
import SteeringClockForm from '../../components/forms/SteeringClockForm';
import SteeringClocksTable from '../../components/tables/SteeringClocksTable';
import { useProductManager } from '../../hooks/useProductManager';
import { STORE_NAMES } from '../../utils/db';

const SteeringClocksPage: React.FC = () => {
  const [search, setSearch] = React.useState('');

  const {
    items: steeringClocks,
    currentItem,
    setCurrentItem,
    isModalVisible,
    setIsModalVisible,
    addItem: handleAddSteeringClocks,
    deleteItem: handleDelete,
    exportToExcel,
  } = useProductManager<SteeringClockItem>(STORE_NAMES.steeringClocks);

  const handleEdit = (item: SteeringClockItem) => {
    setCurrentItem(item);
    setIsModalVisible(true);
  };

  const filtered = React.useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return steeringClocks;
    return steeringClocks.filter(item =>
      [item.brand, item.partNumber, item.model, item.original, String(item.price)]
        .filter(Boolean)
        .some(v => String(v).toLowerCase().includes(q))
    );
  }, [steeringClocks, search]);

  const totalCount = steeringClocks.length;
  const shownCount = filtered.length;

  return (
    <div>
      <div className="products-toolbar">
        {/* flexWrap обязателен: без него ряд не помещался на телефоне
            и правые кнопки уходили за край экрана — «Все» была видна
            наполовину и не нажималась. */}

        <Button type="primary" onClick={() => { setIsModalVisible(true); setCurrentItem(null); }}>
          Добавить рулевой шлейф
        </Button>

        <Button onClick={() => exportToExcel('SteeringClocks_Export')}>
          📁 Экспорт в Excel
        </Button>

        <Input
          placeholder="Поиск…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="products-search"
          allowClear
        />

        <Tag className="small-tag">Всего: {totalCount}</Tag>
        <Tag color="blue" className="small-tag">Показано: {shownCount}</Tag>

      </div>

      <SteeringClocksTable data={filtered} onEdit={handleEdit} onDelete={handleDelete} />

      <Modal
        title={currentItem ? 'Редактировать рулевой шлейф' : 'Добавить рулевой шлейф'}
        open={isModalVisible}
        onCancel={() => { setIsModalVisible(false); setCurrentItem(null); }}
        footer={null}
        destroyOnHidden
      >
        <SteeringClockForm onAdd={handleAddSteeringClocks} initialValues={currentItem} />
      </Modal>
    </div>
  );
};

export default SteeringClocksPage;
